if (!customElements.get('wlsn-tab-triggers')) {
    class WLSNTabTriggers extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                openClass: 'is-active',
                trigger: 'js-wlsn-tab-trigger',
                content: 'js-wlsn-affiliate-product'
            };

            this.elements = {
                triggers: this.querySelectorAll(`.${this.classes.trigger}`),
                contents: document.querySelectorAll(`.${this.classes.content}`),
            };
        }

        connectedCallback() {
            this.init();
        }

        init() {
            if (!this.elements.triggers.length) return;

            this.elements.triggers.forEach((trigger) => {
                trigger.addEventListener('click', () => {
                    const index = trigger.dataset.index;

                    this.handleTriggerClick(index);
                });
            });

            // inicijalni state
            this.handleTriggerClick(0);
        }

        handleTriggerClick(index) {
            // reset triggera
            this.elements.triggers.forEach((trigger) => {
                trigger.classList.remove(this.classes.openClass);
            });

            // aktivan trigger
            const activeTrigger = this.querySelector(
                `[data-index="${index}"]`
            );

            if (activeTrigger) {
                activeTrigger.classList.add(this.classes.openClass);
            }

            // sakrij sve contente
            this.elements.contents.forEach((content) => {
                content.classList.remove(this.classes.openClass);
            });

            // prikazi odgovarajuci content
            const activeContent = document.querySelector(
                `.js-wlsn-affiliate-product-${parseInt(index) + 1}`
            );

            if (activeContent) {
                activeContent.classList.add(this.classes.openClass);
            }
        }

        disconnectedCallback() {}
    }

    customElements.define('wlsn-tab-triggers', WLSNTabTriggers);
}